import _ from 'lodash'

export const getAllBots = (state) => _.get(state, 'bot.bots', [])
export const getBotById = (state, id) => {
  const bots = getAllBots(state)
  return _.find(bots, { id }) || {}
}

export const getBotFlows = (state, botId) => _.get(state, `bot.flows.${botId}`, [])

export const getAllCampaigns = (state) => {
  const bots = getAllBots(state)
  const campaigns = []
  bots.forEach((bot) => {
    if (bot.settings.campaign_rules?.length) {
      campaigns.push(...bot.settings.campaign_rules)
    }
  })
  return campaigns
}

export const getSpecificCampaign = (state, id) => {
  const campaigns = getAllCampaigns(state)
  return _.find(campaigns, { id }) || {}
}

export const getDefaultFlowId = (state, botId) => {
  const flows = _.get(state, `bot.flows.${botId}`, [])
  return flows.at(-1)?.id
}
